import { Reducer } from 'redux';

import { Publishers } from '../types';

import { attachmentActionsReducer } from './attachmentActionsReducer';
import { audienceActionsReducer } from './audienceActionsReducer';
import { closeActionsReducer } from './closeActionsReducer';
import { contentActionsReducer } from './contentActionsReducer';
import { openActionsReducer } from './openActionsReducer';
import { PublishersAction } from './reducer.types';
import { topicActionsReducer } from './topicActionsReducer';

const initialState: Publishers = {};

const reducer: Reducer<Publishers, PublishersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUBLISHER.REMOVE_ALL':
      return initialState;
    default:
      return [
        openActionsReducer,
        closeActionsReducer,
        contentActionsReducer,
        topicActionsReducer,
        attachmentActionsReducer,
        audienceActionsReducer,
      ].reduce((prevState, reducer) => reducer(prevState, action), state);
  }
};

export default reducer;
